import { useFormField } from '@calendly/form';
import { FieldLabel } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
const statusToggleCss = "s1nmt5cr";
const StatusToggle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(statusToggleCss, props.className)} />;
});
export const StatusField = ({
  name,
  className,
  disabled,
  etLocked = false
}) => {
  const [{
    value: enabled
  }, _, {
    setValue
  }] = useFormField({
    name
  });
  return <div className={className}>
      <FieldLabel text={I18n.t('publisher.organization.headers.status')} />
      {!etLocked && <StatusToggle>
          <div>
            {enabled ? I18n.t('publisher.action.on') : I18n.t('publisher.action.off')}
          </div>
          <SwitchInput checked={enabled} disabled={disabled} onChange={() => setValue(!enabled)} />
        </StatusToggle>}
      {etLocked && <div>
          {enabled ? I18n.t('publisher.action.on') : I18n.t('publisher.action.off')}
        </div>}
    </div>;
};

require("./status_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./status_field.js");